import { RouterProvider } from 'react-router';
import { AuthProvider } from '#client/providers/AuthProvider';
import { ThemeProvider } from '#client/providers/ThemeProvider';
import { ToastProvider } from '#client/providers/ToastProvider';
import { router } from '#client/router';

/**
 * ThemeProvider sits outermost deliberately: it is the only provider whose
 * value changes on a user preference rather than on data, and nothing below it
 * consumes theme through context (components read CSS variables). Putting it
 * here means flipping the theme never re-renders the router subtree.
 */
export function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}
